export const AutoProjectStatusTabs = {
    ImageCollection: 0,
    TrainingStatus: 1
};
